import { render, staticRenderFns } from "./requestLogListing.vue?vue&type=template&id=68822af2&"
import script from "./requestLogListing.vue?vue&type=script&lang=js&"
export * from "./requestLogListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports